import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { isUserCompleted } from '../../../../../../contexts/User/helpers/userTypeHandlers';
import { isProgramProgressReachedEnd } from '../../../../../../selectors/participant/isProgramProgressReachedEnd';
import { FinishedNotification, StepControls } from '../../../components/StepControls';
import { FormQuizControls } from '../../../components/FormQuizControls';
import { sidebarLayoutDataHooks } from '../sidebarLayoutDataHooks';
import { IFollowingEntity } from '../../utils';
import { Props } from '../interfaces';

export interface BaseControlsProps {
  props: Props;
  currentStep: ParticipantStep | null;
  isProgramFinished: boolean;
  getQuizData: () => any;
  onStepResolve: (step: ParticipantStep) => Promise<void>;
  onNextEntity: (nextEntity: IFollowingEntity, withBI?: boolean) => Promise<void>;
}

export const BaseControls: React.FC<BaseControlsProps> = ({
  props,
  currentStep,
  isProgramFinished,
  getQuizData,
  onStepResolve,
  onNextEntity,
}) => {
  const {
    challengeData,
    participant,
    isParticipantInSuspendedState,
    isParticipantInLockedState,
  } = props;
  const isStepActive = !!currentStep?.id;
  const isParticipantInNegativeState =
    isParticipantInSuspendedState || isParticipantInLockedState;
  const { isQuiz } = getQuizData();
  const isCompletedChallenge =
    isUserCompleted(participant?.transitions?.[0]?.state) ||
    isProgramProgressReachedEnd(challengeData?.challenge, participant) ||
    isProgramFinished;

  const shouldShowBaseControls =
    (isStepActive || isQuiz) && !isParticipantInNegativeState;

  if (isCompletedChallenge) {
    return <FinishedNotification />;
  } else if (!shouldShowBaseControls) {
    return null;
  }

  return (
    <>
      {isStepActive && !isQuiz ? (
        <StepControls
          completeBtnDataHook={sidebarLayoutDataHooks.stepCompleteBtn()}
          nextBtnDataHook={sidebarLayoutDataHooks.stepNextBtn()}
          currentStep={currentStep}
          steps={props.participantSteps}
          sections={props.listParticipantSections}
          buttonState={props.buttonState}
          onStepResolve={(step) => onStepResolve(step)}
          onNextEntity={(entity) => onNextEntity(entity)}
        />
      ) : null}
      {isQuiz ? (
        <FormQuizControls onNextEntity={(entity) => onNextEntity(entity)} />
      ) : null}
    </>
  );
};
